<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11LNgUT/tc-custom/9781503607132.jpg?1699985118489" alt="This image is the cover for the book Neoliberalism's Demons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neoliberalism's Demons
      </h1>
      <p class="bookDescription body article font2">
        <b>“Adam Kotsko’s premise—that the devil and the neoliberal subject can only ever choose their own damnation—is as original as it is breathtaking.” —James Martel, author of <i>Anarchist Prophets</i></b><br/>  <br/> By both its supporters and detractors, neoliberalism is usually considered an economic policy agenda. <i>Neoliberalism’s Demons</i> argues that it is much more than that: a complete worldview, neoliberalism presents the competitive marketplace as the model for true human flourishing. And it has enjoyed great success: from the struggle for “global competitiveness” on the world stage down to our individual practices of self-branding and social networking, neoliberalism has transformed every aspect of our shared social life. <br/>  <br/> The book explores the sources of neoliberalism’s remarkable success and the roots of its current decline. Neoliberalism’s appeal is its promise of freedom in the form of unfettered free choice. But that freedom is a trap: we have just enough freedom to be accountable for our failings, but not enough to create genuine change. If we choose rightly, we ratify our own exploitation. And if we choose wrongly, we are consigned to the outer darkness—and then demonized as the cause of social ills. By tracing the political and theological roots of the neoliberal concept of freedom, Adam Kotsko offers a fresh perspective, one that emphasizes the dynamics of race, gender, and sexuality. More than that, he accounts for the rise of right-wing populism, arguing that, far from breaking with the neoliberal model, it actually doubles down on neoliberalism’s most destructive features.<br/>  <br/><b>“One of the most compelling critical analyses of neoliberalism I’ve yet encountered, understood holistically as an economic agenda, a moral vision, and a state mission.” —Peter Hallward, author of <i>Badiou</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Kotsko
      </h2>
      
      <p class="authorDescription body article"><B>Adam Kotsko</B> is on the faculty of the Shimer Great Books School of North Central College. His most recent book is <I>The Prince of This World</I> (Stanford, 2016).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stanford University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f538bfbc